<section class="breadcrumb-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-title">
          <h1>Account Details</h1>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-lg std-scholarship">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="inner-title">
          <!-- <h4>Raisoni Group of Institutions Proposed Fees : 2024-25</h4> -->
        </div>
        <div class="table-responsive">
          <table class="table table-bordered tbl_custom">
            <thead>
              <tr>
                <th>Account No.</th>

                <th>IFSC code</th>

                <th>Bank Name</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>624201034889</td>
                <td>ICIC0006242</td>
                <td>ICICI BANK LTD, RAMDASPETH BRANCH</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- <div class="table-responsive" >
                    <table class="table table-bordered tbl_custom">
                        <thead>
                            <tr>
                                <th>Course </th>
                                <th>Branch. </th>
                                <th>Final Fee
                                    2023-24
                                    (Mgmt
                                    Quota)
                                </th>
                                <th>OPEN</th>
                                <th>OBC</th>
                                <th>VJ/NT/
                                    SBC/
                                    TFWS
                                </th>
                                <th>SC/ST</th>
                                <th>OMS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>BBA </td>
                                <td></td>
                                <td>85000</td>
                                <td>85000</td>
                                <td>85000</td>
                                <td>85000</td>
                                <td>85000</td>
                                <td>85000</td>
                            </tr>
                            <tr>
                                <td>BCCA </td>
                                <td></td>
                                <td>28000</td>
                                <td>28000</td>
                                <td>28000</td>
                                <td>28000</td>
                                <td>28000</td>
                                <td>28000</td>
                            </tr>
                            <tr>
                                <td>B.COM (Hons)</td>
                                <td>Honors</td>
                                <td>35000</td>
                                <td>35000</td>
                                <td>35000</td>
                                <td>35000</td>
                                <td>35000</td>
                                <td>35000</td>

                            </tr>
                            <tr>
                                <td>BSC (Finance)</td>
                                <td>Finance</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>


                            </tr>
                            <tr>
                                <td>BSC (Data Science)</td>
                                <td>Data Science</td>
                                <td>52000</td>
                                <td>52000</td>
                                <td>52000</td>
                                <td>52000</td>
                                <td>52000</td>
                                <td>52000</td>


                            </tr>
                            <tr>
                                <td>BSC (Economics)</td>
                                <td>Economics</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>

                            </tr>
                            <tr>
                                <td>BA (Hons in Economics)</td>
                                <td>Hons in Economics</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                            </tr>

                            <tr>
                                <td>BCA</td>
                                <td></td>
                                <td>50000</td>
                                <td>50000</td>
                                <td>50000</td>
                                <td>50000</td>
                                <td>50000</td>
                                <td>50000</td>
                            </tr>
                            <tr>
                                <td>MSc (Com Sci)</td>
                                <td>Computer Science</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                                <td>45000</td>
                            </tr>
                            <tr>
                                <td>MCM</td>
                                <td></td>
                                <td>25000</td>
                                <td>25000</td>
                                <td>25000</td>
                                <td>25000</td>
                                <td>25000</td>
                                <td>25000</td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->
      </div>
    </div>
  </div>
</section>
